import { defineComponent, onMounted, ref, watch } from "vue";
import { LocationSelectService } from "./location-select.service";
import { AreaListRecord } from "./location-select.interface";
import { Form } from "ant-design-vue";
import { bindEmitter } from "@/utils/emitter";
import { useRoute } from "vue-router";

export default defineComponent({
  isGlobal: true,
  name: "LocationSelect",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    changeOnSelect: {
      type: Boolean,
      default: false,
    },
    provinceId: {
      type: [Number, String],
      default: 0,
    },
    cityId: {
      type: [Number, String],
      default: 0,
    },
    districtId: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    class: {
      type: String,
      default: "append-to-parent",
    },
  },
  emits: ["update:provinceId", "update:cityId", "update:districtId", "onSelected"],
  setup(props, { emit }) {
    const options = ref<AreaListRecord[]>([]);
    const route = useRoute();

    const innerValue = ref<Array<String | Number>>([]);
    const formItemContext = Form.useInjectFormItemContext();
    const loadData = async (selectedOptions) => {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      await loadByParentId(targetOption.id, selectedOptions.length === 2);
      targetOption.loading = false;
    };

    const loadByParentId = async (parentId, isLeaf = false) => {
      const records = await LocationSelectService.fetchList({ parentId }, isLeaf);
      options.value = LocationSelectService.attachChildren(options.value, parentId, records);
    };

    const onChange = (value, selectedOptions) => {
      // // console.log(
      //   "🚀 ~ file: location-select.controller.ts:57 ~ onChange ~ value:",
      //   value,
      //   selectedOptions
      // );
      const [provinceId, cityId, districtId] = value || [];
      emit("update:provinceId", provinceId);
      emit("update:cityId", cityId);
      emit("update:districtId", districtId);
      const event = bindEmitter("change-location-region" + (route.name as string));
      if(selectedOptions){
        event({
          province: selectedOptions[0],
          city: selectedOptions[1],
          district: selectedOptions[2],
        });
      }else{
        event(null)
      }
      
      emit("onSelected", {
        province: selectedOptions[0],
        city: selectedOptions[1],
        district: selectedOptions[2],
      });
      formItemContext.onFieldChange();
    };

    onMounted(async () => {
      options.value = await LocationSelectService.fetchList({ parentId: 0 }, false);
    });

    watch(
      [() => props.provinceId, () => props.cityId, () => props.districtId],
      async ([provinceId, cityId, districtId], [prevProvinceId, prevCityId]) => {
        if (provinceId && provinceId !== prevProvinceId && cityId && cityId !== prevCityId) {
          await loadByParentId(provinceId, false);
        }
        if (cityId && cityId !== prevCityId) {
          await loadByParentId(cityId, true);
        }
        if (!provinceId && !cityId && !districtId) {
          innerValue.value = [];
        } else {
          innerValue.value = [provinceId, cityId, districtId];
        }
      },
      { immediate: true }
    );

    return {
      innerValue,
      options,
      loadData,
      onChange,
    };
  },
});
